export const actionTypes: any = {
  GET_CREDIT_CARD_APPLICATION_REPORT_START: 'GET_CREDIT_CARD_APPLICATION_REPORT_START',
  GET_CREDIT_CARD_APPLICATION_REPORT_SUCCESS: 'GET_CREDIT_CARD_APPLICATION_REPORT_SUCCESS',
  GET_CREDIT_CARD_APPLICATION_REPORT_FINISH: 'GET_CREDIT_CARD_APPLICATION_REPORT_FINISH',
}
